module.exports = __webpack_public_path__ + "images/5bb2005fd812c78f57dcb851f6449f07fbed0989f0ea6ce65a7afa992ec9fef6.svg";